import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from "../../services/auth.service";
import {Session} from "../../services/session.service";
import {first, map} from "rxjs/operators";
import {Observable, of} from "rxjs";

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const session = inject(Session);

  if (authService.isAuthenticated()) {
    return of(needsToAcceptTermsAndConditions(state));
  }
  return authService.reloadSession().pipe(
    first(),
    map((isLoggedIn) => {
      if (isLoggedIn) {
        return needsToAcceptTermsAndConditions(state);
      } else {
        const queryParams = state.url !== '/home' ? { returnUrl: state.url } : {};
        router.navigate(['/login'], {
          queryParams: queryParams
        });
        return false;
      }
    })
  );
  function needsToAcceptTermsAndConditions(state: RouterStateSnapshot): boolean {
    /*
    //hide this, they have agreed during registration
    if(state.url !== '/terms-conditions' && !session.isImpersonatedUser() && !session.getTermsAccepted()){
      router.navigate(['/terms-conditions']);
      return false;
    }*/
    return true;
  }

}
